import { useTranslation } from "react-i18next";
import { useRetrieveTransferOrderHistory } from "../../hooks/transfer";
import { StatusBadge } from "../commons/status-badge";


interface Props {
    id: number;
}

export default function TransferHistory(props: Props) {
    const history = useRetrieveTransferOrderHistory({ id: props.id });
    const { t } = useTranslation();

    return (
        <div className={`${!!history?.transitions ? 'transition-opacity duration-300 opacity-100 ease-in' : 'opacity-0'}`}>
            {!!history?.transitions ? (
                <div className="grid grid-flow-row space-y-3 text-left">
                    {history.transitions.map((ot, idx) => (
                        <div key={idx} className="flex flex-row space-x-3 p-3 bg-gray-100 rounded-lg items-center">
                            <div>{ot.timestamp}</div>
                            <div>{ot.username}</div>
                            <StatusBadge status={ot.toState} />
                            <div>
                                {!!ot.position && (
                                    <a className="text-blue-600 hover:text-blue-800" target="_blank" href={`https://www.openstreetmap.org/?mlat=${ot.position.latitude}&mlon=${ot.position.longitude}#map=14/${parseFloat(ot.position.latitude)}/${ot.position.longitude}`}>{t('transition_position')}: {`${parseFloat(ot.position.latitude)}, ${parseFloat(ot.position.longitude)}`}</a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="grid grid-flow-row space-y-3 text-left">
                    <div>loading...</div>
                </div>
            )}
        </div>
    )
}
